import { Heart, PawPrint } from "lucide-react";

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Navigation */}
      <header className="sticky top-0 z-50 bg-background/90 border-b border-border/50"
        style={{ boxShadow: "0 2px 20px -4px oklch(0.52 0.18 145 / 0.12)" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-2xl bg-primary flex items-center justify-center text-xl"
              style={{ boxShadow: "0 4px 12px oklch(0.52 0.18 145 / 0.35)" }}>
              🐶
            </div>
            <span className="font-bold text-lg text-foreground tracking-tight">
              汪汪贴图
              <span className="text-primary ml-1">屋</span>
            </span>
          </div>

          {/* Nav Links */}
          <nav className="hidden sm:flex items-center gap-1">
            {[
              { label: "全部贴图", id: "gallery" },
              { label: "分类浏览", id: "categories" },
              { label: "关于我们", id: "about" },
            ].map((item) => (
              <button
                key={item.id}
                onClick={() => document.getElementById(item.id)?.scrollIntoView({ behavior: "smooth" })}
                className="px-4 py-2 rounded-xl text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted/60 transition-all duration-200"
              >
                {item.label}
              </button>
            ))}
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex items-center gap-1 text-sm text-muted-foreground px-3 py-1.5 rounded-full bg-accent/60">
              <PawPrint className="w-3.5 h-3.5 text-accent-foreground" />
              <span className="font-medium text-accent-foreground">32 款贴图免费</span>
            </div>
          </div>
        </div>
      </header>

      {/* Main */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="border-t border-border/50 bg-muted/30 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-muted-foreground text-sm">
              <span className="text-2xl">🐾</span>
              <span>汪汪贴图屋 · 32 款可爱小狗贴图免费下载</span>
            </div>
            <div className="flex items-center gap-1 text-sm text-muted-foreground">
              <span>Made with</span>
              <Heart className="w-3.5 h-3.5 text-primary fill-primary mx-0.5" />
              <span>for dog lovers</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
